import { useEffect, useState } from 'react';

/**
 * Seconds left until `deadline` (a ms timestamp), ticking once a second.
 * Based on the clock rather than counting ticks, so it stays correct when the tab sleeps.
 * Returns 0 when there's no deadline or it has passed.
 */
export default function useCountdown(deadline) {
  const remaining = () => (deadline ? Math.max(0, Math.ceil((deadline - Date.now()) / 1000)) : 0);
  const [seconds, setSeconds] = useState(remaining);

  useEffect(() => {
    setSeconds(remaining());
    if (!deadline) return undefined;
    const timer = setInterval(() => {
      const left = remaining();
      setSeconds(left);
      if (left === 0) clearInterval(timer);
    }, 1000);
    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deadline]);

  return seconds;
}
